import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

var SEAT_STATUS = {
  AVAILABLE: 'available',
  TAKEN: 'taken',
  TEMPORARY_TAKEN: 'temporary_taken',
  BLOCKED: 'blocked',
  SELECTED: 'selected',
  FIRST_COME_FIRST_SERVE: 'first_come_first_serve'
};

class Seat extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    var seatId = this.props.seatId;
    var status = this.props.status;
    var disabled = this.props.disabled;
    var onClick = this.props.onClick;
    var adminMode = this.props.adminMode;
    var blockedClickable = this.props.blockedClickable;
    var tempHeldClickable = this.props.tempHeldClickable;

    var isFCFS = status === SEAT_STATUS.FIRST_COME_FIRST_SERVE;
    var blockedAndLocked = status === SEAT_STATUS.BLOCKED && !blockedClickable;
    var tempHeldAndLocked = status === SEAT_STATUS.TEMPORARY_TAKEN && !tempHeldClickable;
    if (disabled || status === SEAT_STATUS.TAKEN || tempHeldAndLocked || blockedAndLocked || (isFCFS && !adminMode)) {
      return;
    }

    if (onClick) {
      onClick(seatId);
    }
  }

  render() {
    var seatId = this.props.seatId;
    var status = this.props.status;
    var price = this.props.price;
    var addOn = this.props.addOn;
    var label = this.props.label;
    var disabled = this.props.disabled;
    var adminMode = this.props.adminMode;
    var pending = this.props.pending;
    var pendingRelease = this.props.pendingRelease;

    var isFCFS = status === SEAT_STATUS.FIRST_COME_FIRST_SERVE;
    var blockedClickable = this.props.blockedClickable;
    var tempHeldClickable = this.props.tempHeldClickable;

    var isClickable = !pending && !pendingRelease && !disabled &&
      status !== SEAT_STATUS.TAKEN &&
      (status !== SEAT_STATUS.TEMPORARY_TAKEN || tempHeldClickable) &&
      (status !== SEAT_STATUS.BLOCKED || blockedClickable) &&
      (!isFCFS || adminMode);

    var classNames = ['seat', status];
    if (pending || pendingRelease) { classNames.push('pending'); }
    if (disabled) { classNames.push('disabled'); }
    if (isClickable) { classNames.push('clickable'); }

    if (pendingRelease) {
      return (
        <div
          className={classNames.join(' ')}
          title={'Releasing seat ' + seatId}
        >
          <span className="seat-pending-text">releasing</span>
          <span className="seat-pending-text">seat</span>
        </div>
      );
    }

    if (pending) {
      return (
        <div
          className={classNames.join(' ')}
          title={'Checking availability for seat ' + seatId}
        >
          <span className="seat-pending-text">checking</span>
          <span className="seat-pending-text">availability</span>
        </div>
      );
    }

    var displayLabel;
    var titleText;
    if (isFCFS) {
      displayLabel = 'FCFS';
      titleText = 'Seat ' + seatId + ' - First Come First Serve' + (adminMode ? ' (may be assigned at check-in)' : '');
    } else if (label != null) {
      displayLabel = label;
      titleText = 'Seat ' + seatId;
    } else if (addOn != null) {
      displayLabel = '+$' + (addOn || 0);
      titleText = 'Seat ' + seatId + ' - $' + price + ' ($' + (price - (addOn || 0)) + ' base' + ((addOn || 0) > 0 ? ' + $' + addOn + ' add-on' : '') + ')';
    } else {
      displayLabel = '$' + price;
      titleText = 'Seat ' + seatId + ' - $' + price;
    }

    // Admin context (AddSeatBlock) surfaces extra affordances via portaled
    // tooltips so they don't get clipped by the scrollable .seat-rows container.
    var tooltipText = null;
    if (status === SEAT_STATUS.BLOCKED && blockedClickable) {
      tooltipText = 'Click to unblock seat ' + seatId;
      titleText = tooltipText;
    } else if (status === SEAT_STATUS.TEMPORARY_TAKEN && tempHeldClickable) {
      tooltipText = this.props.tempHeldTooltip || 'Held by a customer — click to block (overrides hold)';
      titleText = tooltipText;
    } else if (status === SEAT_STATUS.SELECTED && (blockedClickable || tempHeldClickable)) {
      tooltipText = 'Click to cancel — seat ' + seatId;
    }

    var seatNode = (
      <div
        className={classNames.join(' ')}
        onClick={this.handleClick}
        title={tooltipText ? undefined : titleText}
      >
        <span className="seat-price">{displayLabel}</span>
      </div>
    );

    if (tooltipText) {
      return (
        <OverlayTrigger
          placement="top"
          delayShow={0}
          delayHide={0}
          overlay={<Tooltip id={'seat-tip-' + seatId}>{tooltipText}</Tooltip>}
        >
          {seatNode}
        </OverlayTrigger>
      );
    }

    return seatNode;
  }
}

export default Seat;
